import React from 'react';
import { ScreenController, TriggerProps } from 'src/feature-app';
import { AltaComunicacionesForm } from 'src/forms/AltaComunicaciones';

export function AltaComunicacionesTrigger({ setSelectedJourney }: TriggerProps): JSX.Element {
	// Usar AltaComunicacionesController si se requiere carga por pincode
	return (
		<>
			<ScreenController selectedJourney={<AltaComunicacionesForm />} closeLayerCallback={close} handleAreYouSureLayer={() => null} notALayer={true} formType="inPage" />
		</>
	);
}
